import { render, staticRenderFns } from "./ReportComponent.vue?vue&type=template&id=3b611768&"
import script from "./ReportComponent.vue?vue&type=script&lang=js&"
export * from "./ReportComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports